import './Card.css'
import './../App.css';
import { useState, useEffect } from 'react';
import dotGnIcon from '../img/dot-green-icon.svg'
import dotGyIcon from '../img/dot-grey-icon.svg'
import acc_gy_icon from '../img/acc-gy-icon.svg'
import acc_gr_icon from '../img/acc-gr-icon.svg'
import acc_or_icon from '../img/acc-or-icon.svg'
import acc_rd_icon from '../img/acc-rd-icon.svg'
import warning_gy_icon from '../img/warning-sm-gy-icon.svg'
//import info_icon from '../img/info-sm-gy-icon.svg'

import DireccionAccumulators from './icons/DireccionAccumulators'; 
import BrakeAccumulators from './icons/BrakeAccumulators'; 


function Card(props){


  //const timeIndicator = 0

  
    const [fadeIn, setFadeIn] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
          setFadeIn(true);
        }, props.index * 0.25); // Reducir el tiempo de retraso a 100ms
        return () => clearTimeout(timer);
      }, [props.index]);
    
      useEffect(() => {
        setFadeIn(false);
        const timer = setTimeout(() => {
          setFadeIn(true);
        }, 100);
        return () => clearTimeout(timer);
      }, [props.filter]);

/*
const open = url => {
    if(props.tkd !=="---"){
        window.open(url)
    }
}
    */

var isLPP = ""
const lppStyle = {
    fontSize:'10px',
  }
  const melStyle = {
    fontSize:'10px',
    color: '#dd5900',
  }
  const pm = {
    fontSize:'10px',
    color: 'tomato',
  }


/*props.modelo =="797B_LPP"?isLPP=<small style={lppStyle}><i>  LPP</i></small>:isLPP=<small style={melStyle}><i>  MEL</i></small>
*/
isLPP = props.modelo === "797B_LPP"
  ? <small style={lppStyle}><i>LPP</i></small>
  : props.modelo === "797B_PTT"
    ? <small style={melStyle}><i>PTT</i></small>
    : <small style={melStyle}><i>MEL</i></small>;




//let color1= '#abfdae'
let color1= '#abfdae'
let color2= '#484848'

const combinedStyles = {
    color: props.online === "online" ? color1 : color2,
    border: props.pm === "true" ? "3px solid gray" : "",
    backgroundColor: props.lpp, 
    border: props.pm === "true" ? "3px solid gray" : props.modelo === "960E"?  "3px solid #4a647d" : "", 
    animationDelay: `${props.index * 0.025}s`,
    filter: 'opacity(1)',
  };



const limit1 = 800
const limit2 = 600

/*---------------- Direccion ---------------------------*/
  const direccionData_798 = [
    { value: props.dir1, acc: getAccIcon(props.dir1), blinkClass: props.dir1 < 600 ? 'blink' : '', className: 'acc-dir-1' },
    { value: props.dir2, acc: getAccIcon(props.dir2), blinkClass: props.dir2 < 600 ? 'blink_b' : '', className: 'acc-dir-2' },
    { value: props.dir3, acc: getAccIcon(props.dir3), blinkClass: props.dir3 < 600 ? 'blink_c' : '', className: 'acc-dir-3' },
    { value: props.dir4, acc: getAccIcon(props.dir4), blinkClass: props.dir4 < 600 ? 'blink' : '', className: 'acc-dir-4' },
    { value: props.dir5, acc: getAccIcon(props.dir5), blinkClass: props.dir5 < 600 ? 'blink_b' : '', className: 'acc-dir-5' },
    { value: props.dir6, acc: getAccIcon(props.dir6), blinkClass: props.dir6 < 600 ? 'blink_c' : '', className: 'acc-dir-6' },
  ];
/*---------------- Direccion ---------------------------*/
  const direccionData_960E = [
  { value: props.dir1, acc: getAccIcon(props.dir1), blinkClass: props.dir1 < 600 ? 'blink' : '', className: 'acc-dir-1' },
  { value: props.dir2, acc: getAccIcon(props.dir2), blinkClass: props.dir2 < 600 ? 'blink_b' : '', className: 'acc-dir-2'},
];
/*---------------- Direccion ---------------------------*/
  const direccionData_797B = [
    { value: props.dir1, acc: getAccIcon(props.dir1), blinkClass: props.dir1 < 600 ? 'blink' : '', className: 'acc-dir-1' },
    { value: props.dir2, acc: getAccIcon(props.dir2), blinkClass: props.dir2 < 600 ? 'blink_b' : '', className: 'acc-dir-2' },
    { value: props.dir3, acc: getAccIcon(props.dir3), blinkClass: props.dir3 < 600 ? 'blink_c' : '', className: 'acc-dir-3' },
  ];
  /*---------------- Direccion ---------------------------*/
  const direccionData_793F = [
    { value: props.dir1, acc: getAccIcon(props.dir1), blinkClass: props.dir1 < 600 ? 'blink' : '', className: 'acc-dir-1' },
    { value: props.dir2, acc: getAccIcon(props.dir2), blinkClass: props.dir2 < 600 ? 'blink_b' : '', className: 'acc-dir-2' },
    { value: props.dir3, acc: getAccIcon(props.dir3), blinkClass: props.dir3 < 600 ? 'blink_c' : '', className: 'acc-dir-3' },
  ];


/*---------------- Frenos ---------------------------*/
/*---------------- Frenos ---------------------------*/
  const brakeData_797B = [
    { value: props.fr1, acc: getAccIcon(props.fr1), blinkClass: props.fr1 < 600 ? 'blink' : '', className: 'acc-fre-1' },
    { value: props.fr2, acc: getAccIcon(props.fr2), blinkClass: props.fr2 < 600 ? 'blink_b' : '', className: 'acc-fre-2' }
  ];
  /*---------------- Frenos ---------------------------*/
  const brakeData_798 = [
    { value: props.fr1, acc: getAccIcon(props.fr1), blinkClass: props.fr1 < 600 ? 'blink' : '', className: 'acc-fre-1' },
    { value: props.fr2, acc: getAccIcon(props.fr2), blinkClass: props.fr2 < 600 ? 'blink_b' : '', className: 'acc-fre-2' },
    { value: props.fr3, acc: getAccIcon(props.fr3), blinkClass: props.fr3 < 600 ? 'blink_c' : '', className: 'acc-fre-3' },
  ];

  /*---------------- Frenos ---------------------------*/
  const brakeData_797F = [
    { value: props.fr1, acc: getAccIcon(props.fr1), blinkClass: props.fr1 < 600 ? 'blink' : '', className: 'acc-fre-1' },
    { value: props.fr2, acc: getAccIcon(props.fr2), blinkClass: props.fr2 < 600 ? 'blink_b' : '', className: 'acc-fre-2' },
    { value: props.fr3, acc: getAccIcon(props.fr3), blinkClass: props.fr3 < 600 ? 'blink_c' : '', className: 'acc-fre-3' },
    { value: props.fr4, acc: getAccIcon(props.fr4), blinkClass: props.fr4 < 600 ? 'blink_c' : '', className: 'acc-fre-1' },
  ];

    /*---------------- Frenos ---------------------------*/
  const brakeData_EEAA = [
    { value: props.fr1, acc: getAccIcon(props.fr1), blinkClass: props.fr1 < 600 ? 'blink' : '', className: 'acc-fre-1' },
    { value: props.fr2, acc: getAccIcon(props.fr2), blinkClass: props.fr2 < 600 ? 'blink_b' : '', className: 'acc-fre-2' }
  ];

  /*---------------- Frenos ---------------------------*/
  //  777 + 793
  const brakeData_777= [
    { value: props.fr1, acc: getAccIcon(props.fr1), blinkClass: props.fr1 < 600 ? 'blink' : '', className: 'acc-fre-1' },
    { value: props.fr2, acc: getAccIcon(props.fr2), blinkClass: props.fr2 < 600 ? 'blink_b' : '', className: 'acc-fre-2' },
    { value: props.fr3, acc: getAccIcon(props.fr3), blinkClass: props.fr3 < 600 ? 'blink_c' : '', className: 'acc-fre-3' },
  ];


/*----------------------------------------------------------------*/

  function getAccIcon(value) {
    if (value <=limit2)  return acc_rd_icon;
    if (value > limit1) return acc_gr_icon;
    if (value > limit2) return acc_or_icon;
    return acc_gy_icon;
  }

/*--------------------- link to open new window to show visor ----------------------*/

const openVisor = () => {

  localStorage.setItem('from_nitro', 'true');

   let url = process.env.NODE_ENV === 'production'
      ? `http://isight.cl/mel/?view=visor&token=abc123&id=${props.tkd}&modelo=${props.modelo}&serie=${props.firm}`
      : `${window.location.origin}?view=visor&token=abc123&id=${props.tkd}&modelo=${props.modelo}&serie=${props.firm}`;

  const win = window.open(url, '_blank');
  win.name = 'visor';
};

const frenoTxt = <div className="acc-fre-txt">FRENO</div>;
const dirTxt = <div className="acc-dir-txt">DIRECCION</div>;

let dateColor = "#838383" //#abfdae

/*----------------------- delay from timestamp "hace 2 horas..." ----------------------------*/

function formatDiffFromUnix(unixSeconds) {

  if (unixSeconds == null) return "--";
  const tsMs = Number(unixSeconds) * 1000; // tus UNIX vienen en segundos
  if (!Number.isFinite(tsMs)) return "--";

  let diffMs = Date.now() - tsMs; // >0 pasado, <0 futuro
  const future = diffMs < 0;
  diffMs = Math.abs(diffMs);

  let difToSeconds = diffMs/1000
  if(difToSeconds > 86400*2){
    dateColor = "tomato"
  }
  if(difToSeconds < (86400*2) && difToSeconds > 86400){ //mayor a 24hrs pero menor a 48
     dateColor = "#ff9900"
  }
  if(difToSeconds < 86400){
    dateColor = "#abfdae"
  }

  const SEC  = 1000;
  const MIN  = 60 * SEC;
  const HOUR = 60 * MIN;
  const DAY  = 24 * HOUR;

  // < 60 segundos
  if (diffMs < MIN) {
    const s = Math.max(1, Math.floor(diffMs / SEC));
    const txt = `${s} seg`;
    return future ? <>en {txt}<br/>&nbsp;</> : <>Hace {txt}<br/>&nbsp;</> ;
    
  }

  // < 60 minutos
  if (diffMs < HOUR) {
    const m = Math.floor(diffMs / MIN);
    const txt = `${m} min`;
    return future ? <>en {txt}<br/>&nbsp;</> : <>Hace {txt}<br/>&nbsp;</> ;
  }

  // < 48 horas
  if (diffMs < 48 * HOUR) {
    const h = Math.floor(diffMs / HOUR);
    const m = Math.floor((diffMs % HOUR) / MIN);
    const hStr = `${h} hr${h === 1 ? "" : "s"}`;
    const mStr = m > 0 ? ` ${m} min` : "";
    return future ? <>en {hStr}<br/>{mStr}</>  : <>Hace {hStr}<br/>{mStr}</> ;
  }



  // ≥ 48 horas
  const d = Math.floor(diffMs / DAY);
  const txt = `${d} dia${d === 1 ? "" : "s"}`;
  return future ? <>en {txt}<br/>&nbsp;</>: <>Hace {txt}<br/>&nbsp;</>;
}

// Calcula el texto en cada render (como ya recibes props nuevos, basta con esto)
const lastText = formatDiffFromUnix(props.last_unix);




/*--------------------------------------------------------------------------------------------*/


return(

//<div className={`card ${fadeIn ? 'fade-in' : ''}`} style={combinedStyles} onClick={openVisor}> 
<div className="card-scale-wrapper">
    <div className={`card ${fadeIn ? 'fade-in' : ''}`} style={combinedStyles} onClick={openVisor}>


    <div className="tkd" style={props.online === "online" ? { color: color1 } : { color: color2 }}>
        {props.tkd.toUpperCase().startsWith("LD") ? "LD" : props.tkd.toUpperCase().startsWith("DZ") ? "DZ" : props.tkd.toUpperCase().startsWith("GR") ? "GR" : "TKD"}
        {isLPP} 
    </div>
    <div className="serie">{props.firm}</div>
    <div className="number" style={props.online==="online"?{color:color1}:{color:color2}}>
    {props.tkd.replace(/^(LD|DZ|TKD|GR)/, '')}
      {props.pm ==="true"?<span style={pm}>&nbsp;&#11044;&nbsp;TRUCK_SHOP</span>:""}
    </div>

    {/*<div className="card-date" >{props.date}</div>*/}
    <div className="card-date" style={{color:dateColor}} >{lastText}</div>
    
    {/* -----------  ONLINE indicator ----------------------*/}

    <div className="online" style={props.online==="online"?{color:color1}:{color:color2}}>  
        <img src={props.online==="online"?dotGnIcon:dotGyIcon} alt = " "/>
            &nbsp;{props.online.toUpperCase()}
    </div>


    {/* -----------  CURRENT TIME STAMP ----------------------*/}


    {/* -----------STEERING ACCUMULATORS ----------------------*/}

    {['798', '798_LPP'].includes(props.modelo)?(
    <div className="direccion">
      <div className="direccion-icons">
        <DireccionAccumulators tkd={props.tkd} data={direccionData_798} />
      </div>
      {dirTxt}
    </div>

    ) : 
    ['994F', '854K', '24M', '777F', '777G', '777','988G', '988H'].includes(props.modelo)? (
      <div className="direccion">
      <div className="direccion-icons">
          {/*-- null -- */}
      </div>
      <div className="acc-dir-txt"></div>
    </div>

    ) : 
    ['793F', '793'].includes(props.modelo)? (
      <div className="direccion">
      <div className="direccion-icons">
          <DireccionAccumulators tkd={props.tkd} data={direccionData_793F} />
      </div>
      {dirTxt}
    </div>

    ) : 
    props.modelo === '960E' ? (
    <div className="direccion">
      <div className="direccion-icons">
        <DireccionAccumulators tkd={props.tkd} data={direccionData_960E} />
      </div>
      {dirTxt}
    </div>

    ) : 
    (
        /* SI SON 797B  */
        <div className="direccion">
          <div className="direccion-icons">
            <DireccionAccumulators tkd={props.tkd} data={direccionData_797B} />
          </div>
          {dirTxt}
        </div>
    )   
    }



  {/* -----------BREAKES ACCUMULATORS ----------------------*/}

    
  {['994F', '854K', '24M', '988G', '988H'].includes(props.modelo)? (
    <div className="freno">
      <BrakeAccumulators tkd={props.tkd} data={brakeData_EEAA} />
      {frenoTxt}
    </div>
  ) : ['777F', '777G', '777','793F'].includes(props.modelo)? (
      <div className="freno">
        <BrakeAccumulators tkd={props.tkd} data={brakeData_777} />
        {frenoTxt}
      </div>
  ) : 
  props.modelo === '797F' ? (
        <div className="freno">
          <BrakeAccumulators tkd={props.tkd} data={brakeData_797F} />
          {frenoTxt}
      </div>
  ):['798', '798_LPP'].includes(props.modelo)?(
      <div className="freno">
          <BrakeAccumulators tkd={props.tkd} data={brakeData_798} />
          {frenoTxt}
      </div>
  ):(
      <div className="freno">
          <BrakeAccumulators tkd={props.tkd} data={brakeData_797B} />
          {frenoTxt}
      </div>

  )}


    {/* ----------- INFO WARNING ICONS ----------------------*/}
    <div className="info">
        <div className="warning-icon">
        <img src={warning_gy_icon} alt = " "/>
        </div>
        <div className="model-icon">
        { /*<img src={info_icon} alt = " "/> */}
        {/*<span>{props.modelo != null ? props.modelo.replace('_LPP', '') : "--"}</span>*/}
        <span>{props.modelo ? props.modelo.replace(/_(LPP|PTT)/, '') : "--"}</span>

        </div>
    </div>
</div>

</div>
    
)}

export default Card
